"use client"

import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"

import { cn } from "@/lib/utils"

function Tabs({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Root>) {
  return (
    <TabsPrimitive.Root
      data-slot="tabs"
      className={cn("flex flex-col gap-2", className)}
      {...props}
    />
  )
}

/** Brutalist segmented control — matches About page (kraft track, mustard active pill). */
function TabsList({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={cn(
        "grid h-auto w-full grid-cols-[repeat(auto-fit,minmax(0,1fr))] items-center gap-1 rounded-[var(--brutal-radius)] border-2 border-[var(--brutal-ink)] bg-[var(--brutal-kraft)] p-1 text-[var(--brutal-ink)] shadow-[var(--brutal-shadow-sm)]",
        className
      )}
      {...props}
    />
  )
}

function TabsTrigger({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      className={cn(
        "inline-flex min-h-9 flex-1 items-center justify-center gap-1.5 rounded-[10px] border-2 border-transparent px-2 py-2 text-xs font-semibold text-[var(--brutal-muted)] transition-[color,background-color,box-shadow,border-color] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brutal-ink)] focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 sm:text-sm",
        "data-[state=active]:border-[var(--brutal-ink)] data-[state=active]:bg-[var(--brutal-mustard)] data-[state=active]:font-bold data-[state=active]:text-[var(--brutal-ink)] data-[state=active]:shadow-[var(--brutal-shadow-sm)]",
        className
      )}
      {...props}
    />
  )
}

function TabsContent({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Content>) {
  return (
    <TabsPrimitive.Content
      data-slot="tabs-content"
      className={cn("flex-1 outline-none", className)}
      {...props}
    />
  )
}

export { Tabs, TabsList, TabsTrigger, TabsContent }
